import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 0 2rem;

	> h2 {
		font-weight: bold;
	}
`;

export const HeaderText = styled.p`
	color: #9f9f9f;
	font-size: 1rem;
	font-weight: bold;
`;

export const Header = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;
export const AreaOptions = styled.div`
	margin: 50px 0;
`;

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
`;

export const HeaderTextScreen = styled.p`
	color: #9f9f9f;
	font-size: 1rem;
	font-weight: bold;
	margin-bottom: 1rem;
`;

export const TextScreen = styled.span`
	color: #7e7e7e;
	font-weight: bold;
	font-size: 0.8125rem;
	text-align: left;
`;

export const App = styled.div`
	text-align: center;
	padding: 20px;
`;

export const UserGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-gap: 10px;
`;

export const UserColumn = styled.div`
	cursor: pointer;
	background-color: #ddd;
	padding: 20px;
	text-align: center;
`;

export const Button = styled.button`
	margin-top: 10px;
`;

export const Title = styled.h6`
	font-weight: bold;
	color: #000;
`;
export const BoxModal = styled.div`
	margin-top: 15px;
	margin-bottom: 25px;
	padding: 20px 15px;
	background-color: #fff;
	-webkit-box-shadow: 4px 4px 5px 0px rgba(197, 197, 197, 1);
	-moz-box-shadow: 4px 4px 5px 0px rgba(197, 197, 197, 1);
	box-shadow: 4px 4px 5px 0px rgba(197, 197, 197, 1);
`;

interface IRowGrid {
	cursorPointer: boolean;
}

export const RowGrid = styled.div<IRowGrid>`
	display: block;
	width: 100%;
	padding: 11px 0;
	cursor: ${(props) => (props.cursorPointer ? "pointer" : "default")};
`;
